import { useCookie } from 'next-cookie';
import { requests } from '@/helpers/api';
import { useMutation } from '@/hooks/useQuery';

const useRequestCall = ({ lang }) => {
  const cookie = useCookie();
  const { mutate: sendContactsFrom, isError, isSuccess, isLoading, reset } = useMutation(requests.sendContactsFrom);

  const onSubmit = (values) => {
    if (!values.clientPhone) return false;

    const roistatVisit = cookie.get('roistat_visit');
    const cookieUtm = cookie.get('utm');
    const utm = cookieUtm ? cookieUtm : {};
    const registerQuery = Object.entries(utm).map(([key, value]) => ({ key, value }));
    registerQuery.push({ key: 'curpage', value: window.location.origin + window.location.pathname });
    if (roistatVisit && !registerQuery.some(({ key }) => key === 'roistat_visit')) registerQuery.push({ key: 'roistat_visit', value: roistatVisit });

    const data = {
      ...values,
      registerQuery,
      roistatVisit
    };

    return sendContactsFrom(data, lang);
  };

  return { onSubmit, isSuccess, isError, isLoading, reset };
};

export { useRequestCall };
